import { MatchListCommon, MatchListStoreModel } from '../../utils/match-list-models';
import { AppAction, SimpleMap } from '@om-fe/store';
import { AggregatorOneOfTypeModel, AggregatorTournamentsModel, DisciplineLiveStatus, ModelTypes } from '@om-fe/models';
import { MatchListItemLayout } from '../../utils/match-list.constants';
import { BreakpointsState } from '@om-fe/core/core/store/breakpoints';

export const FAVORITE_MATCH_AGGREGATOR_PATH: string = 'match-aggregator/:matchId/:nrOfMarkets';
export const FAVORITE_MATCH_AGGREGATOR_PATH_LOGGED_IN: string = 'match-aggregator/logged-in-users/:matchId/:nrOfMarkets';

export const favoriteSlicePrefix: string = 'favorite';

export interface FavoriteMatchListTopic {
    readonly path: string;
    readonly params: {
        readonly matchId: string;
        readonly nrOfMarkets: number;
    };
}

export interface FavoriteMatchListDisciplinesTopic {
    readonly path: string;
    readonly params: {
        readonly matchId: string;
        readonly nrOfMarkets: number;
    };
}

export interface FavoriteMatchListStoreModel {
    readonly ready: boolean;
    readonly matchId: string;
    readonly liveStatus: DisciplineLiveStatus;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly filteredSportIds: string[];
    readonly isDefault?: boolean;
    readonly userID?: string | number;
    readonly mainMarketsLimit?: number;
    readonly mappedDisciplineSet: Record<ModelTypes, Record<string, AggregatorOneOfTypeModel>> | undefined;
    readonly disciplines: Record<string, FavoriteMatchListDisciplineItemStoreModel>;
}

export interface FavoriteMatchListDisciplineItemStoreModel extends MatchListStoreModel {
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
}

export interface FavoriteMatchListDefaultProps {
    readonly hasHeader: boolean;
}

export interface FavoriteMatchListPublicProps extends Omit<MatchListCommon, 'locationId' | 'eventCategoryId' | 'limitNumberOfEvents'> {
    readonly userID?: string | number;
    readonly isDefault?: boolean;
    readonly isLoadingData?: boolean;
    readonly itemLayout?: MatchListItemLayout;
    readonly showMatchListHeader?: boolean;
    readonly showMarketInMatchListGroupHeader?: boolean;
    readonly matchId?: string;
    readonly limitNumberOfEvents?: number;
}

export interface FavoriteMatchListStoreProps {
    readonly sliceKey: string;
    readonly ready: boolean;
    readonly filteredSportIds?: string[];
    readonly isAuthenticated: boolean;
    readonly favoriteMatchIds?: string[];
    readonly breakpoints: BreakpointsState;
}

export enum FavoriteMatchListActionsTypes {
    SetLoadingData = 'sports:live-match-list:set-loading-data',
    SetFilterData = 'sports:live-match-list:set-match-list-filter-data',
}

export interface FavoriteMatchListSetLoadingData extends AppAction<FavoriteMatchListActionsTypes.SetLoadingData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingMoreData: boolean;
    };
}

export interface FavoriteMatchListSetFilterDataAction extends AppAction<FavoriteMatchListActionsTypes.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly matchId: string;
        readonly mainMarketsLimit?: number;
    };
}

export interface FavoritesTournamentsTopicParams {
    readonly topic: string;
    readonly params: SimpleMap;
}

export type FavoritesAggregatorOneOfTypeModel = AggregatorOneOfTypeModel | AggregatorTournamentsModel;
